import React from 'react';
import aboutImg from '../../Image/1.jpg';
import why from '../../Image/5.jpg';
import service from '../../Image/2.webp';
import different from '../../Image/different.jpg';
import './About.css';

const About = () => {
    const sections = [
        {
            title: "Who We Are?",
            text: `Pristine Property Maintenance LLC is a trusted property maintenance partner serving homeowners, landlords, and property management companies across the United States. We specialize in delivering fast, efficient, and cost-effective solutions that keep your properties safe, functional, and market-ready. With a dedicated backend team and a growing network of vetted local vendors, we’re redefining how property maintenance is done.`,
            img: aboutImg,
            imgLeft: false
        },
        {
            title: "Why Choose Pristine Property Maintenance LLC?",
            text: [
                "Fast Turnaround Times – We understand time is money. Our streamlined process ensures work orders are addressed promptly, reducing vacancy periods and tenant complaints.",
                "Dedicated Team – Every client is assigned a responsive account manager who oversees the work from start to finish.",
                "Transparent Communication – You’ll receive timely updates, photos, and documentation at every stage of the process.",
                "Nationwide Vendor Network – We collaborate with licensed and experienced professionals in multiple states, ensuring quality service wherever you need it.",
                "Tech-Driven Efficiency – From work order tracking to photo documentation, our operations are powered by systems that minimize delays and human error."
            ],
            img: why,
            imgLeft: true
        },
        {
            title: "Our Services",
            text: [
                "General Repairs & Handyman Services",
                "Drywall, Painting & Carpentry",
                "Plumbing & Electrical Repairs",
                "Tenant Turn Services",
                "Trash-Outs & Debris Removal",
                "Lawn Care & Landscaping",
                "Winterization & Seasonal Maintenance",
                "Inspection Reports & Estimates",
                "Emergency Response Services",
                "Have a custom request? We’re flexible and client-focused. Just reach out!"
            ],
            img: service,
            imgLeft: false
        },
        {
            title: "How We’re Different",
            text: [
                "Most companies rely on slow processes, vague communication, and inconsistent quality. We don’t.",
                
                "Process optimization to reduce unnecessary delays",
                "A client-first attitude—we treat your property like it’s our own",
                "Affordable pricing without compromising on quality",
                "Flexibility to integrate with your portal or system of choice"
            ],
            img: different,
            imgLeft: true
        }
    ];

    return (
        <div id="About" className="about-section">
            <h2 className="section-title">Pristine Property Maintenance LLC</h2>
            <div className="separator-line bg-black"></div>

            {sections.map((section, index) => (
                <div className="about-row" key={index}>
                    {section.imgLeft && (
                        <div className="about-image">
                            <img src={section.img} alt={section.title} className="imageOne" />
                        </div>
                    )}

                    <div className="about-text">
                        <h3 className="titleTwo">{section.title}</h3>
                        <div className="separator-line bg-black no-margin-lr"></div>
                        {Array.isArray(section.text) ? (
                            <ul>
                                {section.text.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        ) : (
                            <p>{section.text}</p>
                        )}
                    </div>

                    {!section.imgLeft && (
                        <div className="about-image">
                            <img src={section.img} alt={section.title} className="imageOne" />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default About;
